const umbraOpacity = '.05';
const penumbraOpacity = '.07';
const ambientOpacity = '.06';

const focus = `0 0 8px rgba(27, 31, 39,.18),0 8px 16px rgba(27, 31, 39,.36)`;

const penumbra = [
  `0 0 0 0 rgba(27, 31, 39, 0)`,
  `0 2px 2px 0 rgba(27, 31, 39, ${penumbraOpacity})`,
  `0 3px 4px 0 rgba(27, 31, 39, ${penumbraOpacity})`,
  `0 4px 5px 0 rgba(27, 31, 39, ${penumbraOpacity})`,
  `0 6px 10px 0 rgba(27, 31, 39, ${penumbraOpacity})`,
  `0 8px 10px 1px rgba(27, 31, 39, ${penumbraOpacity})`,
  `0 16px 24px 2px rgba(27, 31, 39, ${penumbraOpacity})`,
  `0  9px 46px  8px rgba(27, 31, 39, ${penumbraOpacity})`,
];

const umbra = [
  `0 0 0 0 rgba(27, 31, 39, 0)`,
  `0 3px 1px -2px rgba(27, 31, 39, ${umbraOpacity})`,
  `0 3px 3px -2px rgba(27, 31, 39, ${umbraOpacity})`,
  `0 2px 4px -1px rgba(27, 31, 39, ${umbraOpacity})`,
  `0 3px 5px -1px rgba(27, 31, 39, ${umbraOpacity})`,
  `0 5px 5px -3px rgba(27, 31, 39, ${umbraOpacity})`,
  `0  8px 10px -5px rgba(27, 31, 39, ${umbraOpacity})`,
  `0 24px 38px  3px rgba(27, 31, 39, ${umbraOpacity})`,
];

const ambient = [
  `0 0 0 0 rgba(27, 31, 39, 0)`,
  `0 1px 5px 0 rgba(27, 31, 39, ${ambientOpacity})`,
  `0 1px 8px 0 rgba(27, 31, 39, ${ambientOpacity})`,
  `0 1px 10px 0 rgba(27, 31, 39, ${ambientOpacity})`,
  `0 1px 18px 0 rgba(27, 31, 39, ${ambientOpacity})`,
  `0 3px 14px 2px rgba(27, 31, 39, ${ambientOpacity})`,
  `0  6px 30px 5px rgba(27, 31, 39, ${ambientOpacity})`,
  `0 11px 15px -7px rgba(27, 31, 39, ${ambientOpacity})`,
];

export default Array(8)
  .fill(null)
  .reduce((acc, n, curr) => {
    acc[curr] = `${umbra[curr]}, ${penumbra[curr]}, ${ambient[curr]}`;
    return acc;
  }, {});
